export default __webpack_public_path__ + "static/media/9.0d21c1ab.jpg";